const KEY = 'uma_admin_token';
const ADMIN_KEY = 'uma_admin_profile';

export function getToken() {
  return localStorage.getItem(KEY) || '';
}

export function setToken(token) {
  if (!token) return;
  localStorage.setItem(KEY, token);
}

export function clearToken() {
  localStorage.removeItem(KEY);
}

export function getAdminProfile() {
  const raw = localStorage.getItem(ADMIN_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setAdminProfile(profile) {
  if (!profile) return;
  localStorage.setItem(ADMIN_KEY, JSON.stringify(profile));
}

export function clearAdminProfile() {
  localStorage.removeItem(ADMIN_KEY);
}

